import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class CustomMessageRegionEntity {
  region?: RegionMiniEntity | null;
  districtIds?: Array<number> | null;
}